<div class="register-forms-header">
  <div class="text-center font-xl fw-bold uppercase">
    {{'auth.createAnAccount' | translate}}
  </div>

  <div class="d-flex justify-content-center flex-wrap font-md mt-1">
    <div class="me-2"
         [translate]="'auth.doYouHaveAccount'">
    </div>
    <div class="text-pink pointer hover-underline"
         [translate]="'auth.topHeader.login'"
         (click)="onFormChange.emit()"></div>
  </div>
</div>

<div class="account-tabs-switcher d-flex justify-content-center">
  <div class="pointer account-type-tab"
       (click)="changeTab(USER_ACCOUNT_TYPE.GENERAL)">
    <div [class.account-type-active]="activeTab === USER_ACCOUNT_TYPE.GENERAL"
         [translate]="'auth.topHeader.privateAccount'">Private account
    </div>
  </div>
  <div class="pointer account-type-tab"
       (click)="changeTab(USER_ACCOUNT_TYPE.SHARED_BUSINESS_ACCOUNT)">
    <div [class.account-type-active]="activeTab === USER_ACCOUNT_TYPE.SHARED_BUSINESS_ACCOUNT"
         [translate]="'auth.topHeader.businessAccount'">Business account
    </div>
  </div>
</div>

<ng-content></ng-content>
